import messages from './tag-messages.js';
export default [{
        tag: 'E6',
        intlLabel: messages.E6
    },
    {
        tag: 'E3',
        intlLabel: messages.E3
    }
];
